import { PropsWithChildren } from 'react'

type CustomTooltipWrapperProps = PropsWithChildren & {
    label: string
    tooltipItemsWrapperClassname?: string
}

export const CustomTooltipWrapper: React.FC<CustomTooltipWrapperProps> = (
    props
) => {
    const { label, children } = props
    const defaultWrapperClassname =
        'grid grid-cols-[repeat(2,auto)] gap-y-1 z-[50]'
    const tooltipItemsWrapperClassname =
        props.tooltipItemsWrapperClassname ?? defaultWrapperClassname

    return (
        <div className="relative rounded-lg border border-neutral-200 bg-white px-3 py-2 shadow-sm">
            <div className="space-y-2">
                <div className="text-heading-7">{label}</div>
                <div className={tooltipItemsWrapperClassname}>{children}</div>
            </div>
        </div>
    )
}
